<template>
  <el-dialog title="修改收货地址" v-model="dislogVisible" width="500px">
    <el-form ref="form" :model="form" rules="formRules" label-width="80px">
      <el-form-item label="原 地 址">
        <span>
          {{ this.originAddress }}
        </span>
      </el-form-item>
      <el-form-item label="省市区" prop="region">
        <el-cascader
          size="small"
          :options="options"
          v-model="form.region"
          @change="handleChange"
          class="fix-width"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="receiveAddress">
        <el-input
          v-model="form.receiveAddress"
          placeholder="请输入详细地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dislogVisible = false">取 消</el-button>
      <el-button type="primary" @click="updateAddress">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { updateOrder } from '@/api/order'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'AddressEdit',
  emits: ['fetch-data'],
  data() {
    return {
      dislogVisible: false,
      options: regionData,
      showForm: {},
      originAddress: '',
      form: {
        region: [],
        receiveProvince: '',
        receiveCity: '',
        receiveDistrict: '',
        receiveAddress: '',
      },
      formRules: {
        region: [],
        receiveAddress: [
          { required: true, trigger: 'blur', message: '请输入详细地址' },
        ],
      },
    }
  },
  methods: {
    showEdit(showForm) {
      this.showForm = showForm

      this.form.receiveAddress =
        showForm.basic.contact && showForm.basic.contact.receiveAddress
      this.form.receiveProvince =
        showForm.basic.contact && showForm.basic.contact.receiveProvince
      this.form.receiveCity =
        showForm.basic.contact && showForm.basic.contact.receiveCity
      this.form.receiveDistrict =
        showForm.basic.contact && showForm.basic.contact.receiveDistrict
        this.form.region = [],
      //   const code1 = TextToCode[this.form.receiveProvince][this.form.receiveCity][this.form.receiveDistrict]
      //   console.log(code1)
      //   const code2 = TextToCode[this.form.receiveCity].code
      //   const code3 = TextToCode[this.form.receiveDistrict].code
      //   this.form.region = [code1,code2,code3]
      this.originAddress = `${this.form.receiveProvince}-${this.form.receiveCity}-${this.form.receiveDistrict}${this.form.receiveAddress}`
      this.dislogVisible = true
    },
    handleChange() {
      this.form.receiveProvince = CodeToText[this.form.region[0]]
      this.form.receiveCity = CodeToText[this.form.region[1]]
      this.form.receiveDistrict = CodeToText[this.form.region[2]]
      console.log(this.form)
    },
    updateAddress() {
        if (!this.form.receiveProvince || !this.form.receiveCity || !this.form.receiveDistrict) {
          this.$message.error('收货地址不能为空！')
          return
        }
        if (!this.form.receiveAddress) {
          this.$message.error('详细地址不能为空！')
          return
        }
            const data = Object.assign({},this.form)
            delete data.region
            data.orderId = this.showForm.orderId
          updateOrder(data)
          .then((res) => {
            if (!res) return
            this.dislogVisible = false
            this.$message.success('更新收货地址成功！')
            this.$emit('fetch-data')
          })
          .finally(() => {
            this.shipLoading = false
          })
    }
  },
}
</script>
<style scoped>
.fix-width {
  width: 215px;
}
</style>
